import { formatNumber } from '@dec/shared';
import { ClockHistory, CurrencyDollar, DoorClosed, People, Percent } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import Indicator from '../../../components/Indicator';
import { useGetComplianceStatistics } from '../hooks';

export const ContainerStatistics = ({ search }: { search: any }) => {
  const { t } = useTranslation();
  const [{ data, loading, error }] = useGetComplianceStatistics(search);

  if (loading || error) {
    return <></>;
  }

  const labelCountTaxpayerNotified = t('non-compliances.label.countTaxpayerNotified');
  const labelCountTaxpayerCompliance = t('non-compliances.label.countTaxpayerCompliance');
  const labelCompliancePercentage = t('non-compliances.label.compliancePercentage');
  const labelElapsed = t('non-compliances.label.elapsedTime');
  const labelDebtGenerated = t('non-compliances.label.debtGenerated');
  const labelDays = t('non-compliances.label.days');

  if (data === undefined || (data as any) === '') {
    return (
      <>
        <div className="h-25">
          <div className="d-flex align-self-center align-items-center justify-content-center">
            <div>{t('common.label.noFound')}</div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="card-group">
        <div className="row equal-height">
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={People}
              title={labelCountTaxpayerNotified}
              value={data.countTaxpayerNotified}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={DoorClosed}
              title={labelCountTaxpayerCompliance}
              value={data.countTaxpayerCompliance}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={Percent}
              title={labelCompliancePercentage}
              value={`${data.compliancePercentage} %`}
            />
          </div>

          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={ClockHistory}
              title={labelElapsed}
              value={`${data.elapsedTimeDays} ${labelDays}`}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2">
            <Indicator
              icon={CurrencyDollar}
              title={labelDebtGenerated}
              value={formatNumber(data.debtGenerated as number)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
